import type { FunctionComponent } from 'react';
import { getSanityAssetFullUrl, type Env } from '@fff-web/constants';
import { SALE_TYPE } from '../../../../constants';
import Product from '../../Product';
import Box from '../Box';
import * as styles from './styles.module.scss';

type ProductsProps = {
  products: {
    productType: string;
    items: {
      name: string;
      brandName: string;
      priceInCents: number;
      quantity: number;
      imageUrl: string;
      autoAssigned: boolean;
      slug: string;
    }[];
  }[];
};

const Products: FunctionComponent<ProductsProps> = ({ products }) => (
  <>
    {products.map((product, index) => {
      const { productType, items = [] } = product;
      if (productType === 'box') {
        return <Box key={index} box={product} />;
      }

      return (
        <div key={productType} className={styles.program} data-testid="products-container">
          {products.length > 1 && <h2>{SALE_TYPE[productType]}</h2>}
          <ul>
            {items.map(
              (
                { name, brandName, priceInCents, quantity, imageUrl, autoAssigned, slug },
                itemIndex,
              ) => (
                <Product
                  key={itemIndex}
                  name={name}
                  brandName={brandName}
                  price={priceInCents / 100}
                  quantity={quantity}
                  imageUrl={getSanityAssetFullUrl(
                    imageUrl,
                    process.env.REACT_APP_ENVIRONMENT as Env,
                  )}
                  autoAssigned={autoAssigned}
                  slug={slug}
                />
              ),
            )}
          </ul>
        </div>
      );
    })}
  </>
);

export default Products;
